import './createLine.scss';
var htmlContent = require('./createLine.html');
import $ from 'jquery';
import { BaseModalContent } from '../../shared/components/base-modal-content';
import { HttpService } from '../../core/http/http';
import { Validator } from '../../core/validator/validator';
import { ToastService } from '../../shared/services/toastService';
import { DropDownComponent } from '../../shared/components/drop-down/dropDown';

const renderMarkup = () => htmlContent;

export class CreateLineComponent extends BaseModalContent {
  constructor(areaId, companyId) {
    super(renderMarkup());
    this.httpService = new HttpService();
    this.areaId = areaId;
    this.companyId = companyId;
    this.value = null;
    this.toastService = new ToastService();
  }

  onCreated() {
    this.init();
  }

  init() {
    this.parentModal.container.find('.cancel').click(() => this.cancel());
    this.parentModal.container.find('.create').click(() => this.create());
    this.buildLineNameSelector();
    this.validator = new Validator(this.parentModal.container);
    this.validator.validate();
  }

  buildLineNameSelector() {
    let lineNameSelector = new DropDownComponent(
      document.getElementById('line-name-selctor'),
      true
    );
    lineNameSelector.setRules({
      required: true
    });
    lineNameSelector.loadRemote(
      `${this.httpService.config.loadBudgetGroups}?idEmpresa=${this.companyId}&idArea=${this.areaId}`,
      'nombre',
      'nombre'
    );
    lineNameSelector.onChanges.listen(lineObj => {
      this.value = {};
      this.value.name = lineNameSelector.getValue();
    });

    $('.dropdown').attr('max-length', 100);
  }

  cancel() {
    this.value = null;
    this.parentModal.close();
  }

  create() {
    this.validator.validate();
    if (!this.validator.isValid) {
      return;
    }

    this.parentModal.close();
  }

  get result() {
    return this.value;
  }
}
